import React, { ReactElement } from 'react';
import { StyledLabel } from './styles';
type props = {
  children: string
  color?: string
};
export default function Label(props: Readonly<props>): ReactElement {
  return (
    <StyledLabel color={props.color}>
        {props.children}
    </StyledLabel>
  );
}
